import { BsEyeFill } from 'react-icons/bs';
import { useNavigate } from 'react-router';

interface IProps {
  item: any;
}

const ListRowItem = (props: IProps) => {
  const { item } = props;
  const navigate = useNavigate();
  return (
    <tr>
      <td data-label="Requester" className="text-capitalize">
        {item?.requester || '-'}
      </td>
      <td data-label="Name" className="text-capitalize">
        {item?.name || '-'}
      </td>
      <td data-label="Email">{item?.email || '-'}</td>
      <td data-label="Phone">{item?.phone || '-'}</td>
      <td data-label="Move-in Date" className="text-capitalize">
        {item?.moveIn || '-'}
      </td>
      <td data-label="Budget" className="text-capitalize">
        <span className="price-tag">
          {item?.budget ? `₹${item?.budget}` : '-'}
        </span>
      </td>
      <td data-label="Pets" className="text-capitalize">
        {item?.withPet || '-'}
      </td>
      <td data-label="Gender" className="text-capitalize">
        {item?.gender || '-'}
      </td>

      <td data-label="Action" className="text-end-responsive">
        <div className="d-flex align-items-center justify-content-center gap-2 action-group">
          <button
            type="button"
            className="btn-action btn-action-view"
            title="View Request"
            onClick={() => navigate(`/dashboard/request/${item?._id}`)}
          >
            <BsEyeFill />
          </button>
        </div>
      </td>
    </tr>
  );
};

export default ListRowItem;
